import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'
import CookieConsentVue from '@/plugin/CookieConsentVue.js'

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(CookieConsentVue, {
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        marketing: {}
    },
    language: {
        default: "it",
        autoDetect: "browser",
        translations: {
            it: {
                consentModal: {
                    title: "Consenso cookie",
                    description: "Noi e terze parti selezionate utilizziamo cookie o tecnologie simili per finalità tecniche e, con il tuo consenso, anche per le finalità di funzionalità, esperienza, misurazione e “marketing (con annunci personalizzati)” come specificato nella <a href='/cookie-policy'>cookie policy</a>. "+
                      "Puoi liberamente prestare, rifiutare o revocare il tuo consenso, in qualsiasi momento, accedendo al pannello delle preferenze. Il rifiuto del consenso può rendere non disponibili le relative funzioni." +
                      "Usa il pulsante “Accetta Tutto” per acconsentire. Chiudi questa informativa per continuare senza accettare.",
                    acceptAllBtn: "Accetta tutto",
                    acceptNecessaryBtn: "Rifiuta tutto",
                    showPreferencesBtn: "Gestisci preferenze"
                },
                preferencesModal: {
                    title: "Centro preferenze per il consenso",
                    acceptAllBtn: "Accetta tutto",
                    acceptNecessaryBtn: "Rifiuta tutto",
                    savePreferencesBtn: "Salva le preferenze",
                    closeIconLabel: "Chiudi la finestra",
                    serviceCounterLabel: "Servizi",
                    sections: [
                        {
                            description: "I cookie sono stringhe di testo che i siti web visitati dall’utente (c.d. “prime parti”) ovvero siti web o web server diversi (c.d. “terze parti”) posizionano e archiviano, direttamente (nel caso di siti prime parti) o indirettamente, cioè per il tramite di questi ultimi (nel caso delle terze parti) all’interno di un dispositivo terminale nella disponibilità dell’utente medesimo."
                        },
                        {
                            title: "Cookie Strettamente Necessari <span class=\"pm__badge\">Sempre Attivati</span>",
                            description: "Utilizzati al solo fine di consentire il funzionamento del sito.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Cookie Pubblicitari",
                            description: "utilizzati al fine di ricondurre a soggetti determinati specifiche azioni o schemi comportamentali, in modo da creare dei profili di utenti e inviare messaggi promozionali in linea con le preferenze manifestate dall’utente nella navigazione od offrire all’utente contenuti personalizzati.",
                            linkedCategory: "marketing"
                        }
                    ]
                }
            }
        }
    },
    onFirstConsent(consent) {
        if (consent && consent.cookie.categories && consent.cookie.categories.indexOf("marketing") !== -1) {
            window.location.reload(true);
        }
    }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
